import gql from "graphql-tag";
import * as Urql from "urql";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AlertId: { input: any; output: any };
  /**
   * Implement the DateTime<Utc> scalar
   *
   * The input/output is a string in RFC3339 format.
   */
  DateTime: { input: any; output: any };
  DeviceId: { input: any; output: any };
  /** A scalar that can represent any JSON value. */
  JSON: { input: any; output: any };
  /** A scalar that can represent any JSON Object value. */
  JSONObject: { input: any; output: any };
  /**
   * ISO 8601 calendar date without timezone.
   * Format: %Y-%m-%d
   *
   * # Examples
   *
   * * `1994-11-13`
   * * `2000-02-24`
   */
  NaiveDate: { input: any; output: any };
  OperationId: { input: any; output: any };
  OtaUpdateId: { input: any; output: any };
  PasswordResetToken: { input: any; output: any };
  RequestId: { input: any; output: any };
  SemVer: { input: any; output: any };
  TenantId: { input: any; output: any };
  UpdateId: { input: any; output: any };
  Upload: { input: any; output: any };
  UserId: { input: any; output: any };
  VehicleId: { input: any; output: any };
};

export type Alert = {
  __typename?: "Alert";
  /** The timestamp when the alert was created. */
  created: Scalars["DateTime"]["output"];
  /** Data necessary to display the alert -- business rule specific */
  data: Scalars["JSON"]["output"];
  /** The (optional) device this alert is associated with. */
  deviceId?: Maybe<Scalars["DeviceId"]["output"]>;
  /** Event key (unique identifier in combination with `event_type`) -- business rule specific */
  eventKey: Scalars["String"]["output"];
  /** Event type (unique identifier in combination with `event_key`) -- business rule specific */
  eventType: Scalars["String"]["output"];
  /** The alerts unique identifier. */
  id: Scalars["AlertId"]["output"];
  /** Level of the event. */
  level: EventLevel;
  /**
   * The timestamp when the alert was last updated.
   *
   * This will be equal to `created` if the alert has never been updated.
   */
  updated: Scalars["DateTime"]["output"];
};

export enum ApplicationBank {
  Bank_0 = "BANK_0",
  Bank_1 = "BANK_1",
}

export type Battery = {
  __typename?: "Battery";
  /** consumed mAh of the battery, if known */
  consumedMah?: Maybe<Scalars["Float"]["output"]>;
  /** estimated state of charge of battery if known (<https://en.wikipedia.org/wiki/State_of_charge>) */
  stateOfCharge?: Maybe<Scalars["Int"]["output"]>;
  status: BatteryStatus;
  /** measured battery voltage */
  voltage: Scalars["Float"]["output"];
};

export type BatteryCapacityMessage = {
  __typename?: "BatteryCapacityMessage";
  actual: Scalars["Float"]["output"];
  cycleCount: Scalars["Int"]["output"];
  nominal: Scalars["Float"]["output"];
  remaining: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BatteryCapacityQuery = {
  __typename?: "BatteryCapacityQuery";
  current?: Maybe<BatteryCapacityMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BatteryCapacityMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BatteryCapacityMessage>;
};

export type BatteryCapacityQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BatteryCapacityQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BatteryInfoMessage = {
  __typename?: "BatteryInfoMessage";
  batteryCount: Scalars["Int"]["output"];
  soc: Scalars["Int"]["output"];
  soh: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  totalCurrent: Scalars["Int"]["output"];
  totalVoltage: Scalars["Float"]["output"];
  workingState: WorkingState;
};

export type BatteryInfoQuery = {
  __typename?: "BatteryInfoQuery";
  current?: Maybe<BatteryInfoMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BatteryInfoMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BatteryInfoMessage>;
};

export type BatteryInfoQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BatteryInfoQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BatteryStateMessage = {
  __typename?: "BatteryStateMessage";
  data: Scalars["JSONObject"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BatteryStateQuery = {
  __typename?: "BatteryStateQuery";
  current?: Maybe<BatteryStateMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BatteryStateMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BatteryStateMessage>;
};

export type BatteryStateQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BatteryStateQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export enum BatteryStatus {
  Charging = "CHARGING",
  Discharging = "DISCHARGING",
}

export type BatteryWarningMessage = {
  __typename?: "BatteryWarningMessage";
  balanceOverTemp: WarningStatus;
  cellVoltageOver: WarningStatus;
  cellVoltageUnder: WarningStatus;
  chargeOverCurrent: WarningStatus;
  chargeTempLow: WarningStatus;
  dischargeOverCurrent: WarningStatus;
  dischargeTempHigh: WarningStatus;
  dischargeTempLow: WarningStatus;
  faultLevel: WarningStatus;
  internalOverTemp: WarningStatus;
  packTempDiffHigh: WarningStatus;
  packVoltageDiffHigh: WarningStatus;
  socHigh: WarningStatus;
  socLow: WarningStatus;
  tempWireFault: WarningStatus;
  timestamp: Scalars["DateTime"]["output"];
  totalVoltageOver: WarningStatus;
  totalVoltageUnder: WarningStatus;
  voltageWireFault: WarningStatus;
};

export type BatteryWarningQuery = {
  __typename?: "BatteryWarningQuery";
  current?: Maybe<BatteryWarningMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BatteryWarningMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BatteryWarningMessage>;
};

export type BatteryWarningQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BatteryWarningQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsCapacityMessage = {
  __typename?: "BmsCapacityMessage";
  cycleCount: Scalars["Int"]["output"];
  fullCapacity: Scalars["Int"]["output"];
  remainingCapacity: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsCapacityQuery = {
  __typename?: "BmsCapacityQuery";
  current?: Maybe<BmsCapacityMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsCapacityMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsCapacityMessage>;
};

export type BmsCapacityQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsCapacityQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsCurrentMessage = {
  __typename?: "BmsCurrentMessage";
  data: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsCurrentQuery = {
  __typename?: "BmsCurrentQuery";
  current?: Maybe<BmsCurrentMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsCurrentMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsCurrentMessage>;
};

export type BmsCurrentQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsCurrentQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsMaxTemperatureMessage = {
  __typename?: "BmsMaxTemperatureMessage";
  data: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsMaxTemperatureQuery = {
  __typename?: "BmsMaxTemperatureQuery";
  current?: Maybe<BmsMaxTemperatureMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsMaxTemperatureMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsMaxTemperatureMessage>;
};

export type BmsMaxTemperatureQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsMaxTemperatureQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsMaxVoltageMessage = {
  __typename?: "BmsMaxVoltageMessage";
  data: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsMaxVoltageQuery = {
  __typename?: "BmsMaxVoltageQuery";
  current?: Maybe<BmsMaxVoltageMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsMaxVoltageMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsMaxVoltageMessage>;
};

export type BmsMaxVoltageQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsMaxVoltageQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsMinTemperatureMessage = {
  __typename?: "BmsMinTemperatureMessage";
  data: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsMinTemperatureQuery = {
  __typename?: "BmsMinTemperatureQuery";
  current?: Maybe<BmsMinTemperatureMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsMinTemperatureMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsMinTemperatureMessage>;
};

export type BmsMinTemperatureQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsMinTemperatureQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsMinVoltageMessage = {
  __typename?: "BmsMinVoltageMessage";
  data: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsMinVoltageQuery = {
  __typename?: "BmsMinVoltageQuery";
  current?: Maybe<BmsMinVoltageMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsMinVoltageMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsMinVoltageMessage>;
};

export type BmsMinVoltageQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsMinVoltageQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsOutputVoltageMessage = {
  __typename?: "BmsOutputVoltageMessage";
  data: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsOutputVoltageQuery = {
  __typename?: "BmsOutputVoltageQuery";
  current?: Maybe<BmsOutputVoltageMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsOutputVoltageMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsOutputVoltageMessage>;
};

export type BmsOutputVoltageQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsOutputVoltageQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsPackMessage = {
  __typename?: "BmsPackMessage";
  name: Scalars["String"]["output"];
  serial: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsPackQuery = {
  __typename?: "BmsPackQuery";
  current?: Maybe<BmsPackMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsPackMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsPackMessage>;
};

export type BmsPackQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsPackQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsProductMessage = {
  __typename?: "BmsProductMessage";
  hardwareVersion: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  softwareVersion: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsProductQuery = {
  __typename?: "BmsProductQuery";
  current?: Maybe<BmsProductMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsProductMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsProductMessage>;
};

export type BmsProductQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsProductQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsRs485BusMessage = {
  __typename?: "BmsRs485BusMessage";
  /** Continuous error count, if our tracker is cut off */
  continuousErrors: Scalars["Int"]["output"];
  /** The total number of communication errors, possibly due to interference with the communication bus, it jus used for remote diagnosis */
  errors: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsRs485BusQuery = {
  __typename?: "BmsRs485BusQuery";
  current?: Maybe<BmsRs485BusMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsRs485BusMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsRs485BusMessage>;
};

export type BmsRs485BusQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsRs485BusQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsRtcTimeMessage = {
  __typename?: "BmsRtcTimeMessage";
  day: Scalars["Int"]["output"];
  hour: Scalars["Int"]["output"];
  minute: Scalars["Int"]["output"];
  month: Scalars["Int"]["output"];
  second: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  year: Scalars["Int"]["output"];
};

export type BmsRtcTimeQuery = {
  __typename?: "BmsRtcTimeQuery";
  current?: Maybe<BmsRtcTimeMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsRtcTimeMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsRtcTimeMessage>;
};

export type BmsRtcTimeQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsRtcTimeQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsSerialNumberMessage = {
  __typename?: "BmsSerialNumberMessage";
  number: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsSerialNumberQuery = {
  __typename?: "BmsSerialNumberQuery";
  current?: Maybe<BmsSerialNumberMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsSerialNumberMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsSerialNumberMessage>;
};

export type BmsSerialNumberQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsSerialNumberQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsSwitchStateMessage = {
  __typename?: "BmsSwitchStateMessage";
  data: Scalars["JSONObject"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsSwitchStateQuery = {
  __typename?: "BmsSwitchStateQuery";
  current?: Maybe<BmsSwitchStateMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsSwitchStateMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsSwitchStateMessage>;
};

export type BmsSwitchStateQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsSwitchStateQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsTemperatureMessage = {
  __typename?: "BmsTemperatureMessage";
  cellSensorCount: Scalars["Int"]["output"];
  cellTemps: Array<Scalars["Int"]["output"]>;
  mosfetSensorCount: Scalars["Int"]["output"];
  mosfetTemps: Array<Scalars["Int"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsTemperatureQuery = {
  __typename?: "BmsTemperatureQuery";
  current?: Maybe<BmsTemperatureMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsTemperatureMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsTemperatureMessage>;
};

export type BmsTemperatureQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsTemperatureQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BmsVoltage = {
  __typename?: "BmsVoltage";
  balanceState: Scalars["JSONObject"]["output"];
  cellCount: Scalars["Int"]["output"];
  voltage: Array<Scalars["Int"]["output"]>;
};

export type BmsVoltageInfoMessage = {
  __typename?: "BmsVoltageInfoMessage";
  data: BmsVoltage;
  timestamp: Scalars["DateTime"]["output"];
};

export type BmsVoltageInfoQuery = {
  __typename?: "BmsVoltageInfoQuery";
  current?: Maybe<BmsVoltageInfoMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BmsVoltageInfoMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BmsVoltageInfoMessage>;
};

export type BmsVoltageInfoQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BmsVoltageInfoQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BootMessage = {
  __typename?: "BootMessage";
  panicMessage?: Maybe<Scalars["String"]["output"]>;
  resetReason: ResetReason;
  timestamp: Scalars["DateTime"]["output"];
};

export type BootQuery = {
  __typename?: "BootQuery";
  current?: Maybe<BootMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<BootMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<BootMessage>;
};

export type BootQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type BootQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type BulkOperation = {
  __typename?: "BulkOperation";
  author: User;
  cancelled: Scalars["Int"]["output"];
  completed: Scalars["Int"]["output"];
  created: Scalars["DateTime"]["output"];
  expired: Scalars["Int"]["output"];
  failed: Scalars["Int"]["output"];
  inProgress: Scalars["Int"]["output"];
  kind: BulkOperationKind;
  lastEditedBy?: Maybe<User>;
  operationId: Scalars["OperationId"]["output"];
  pending: Scalars["Int"]["output"];
  target?: Maybe<DfuTarget>;
  targetVersion?: Maybe<Scalars["String"]["output"]>;
  total: Scalars["Int"]["output"];
};

export enum BulkOperationKind {
  /** Bulk operation for device OTA updates */
  OtaUpdate = "OTA_UPDATE",
  /** Bulk operation for device reboots */
  Reboot = "REBOOT",
}

export type CellTemperatureInfoMessage = {
  __typename?: "CellTemperatureInfoMessage";
  average: Scalars["Int"]["output"];
  max: Scalars["Int"]["output"];
  maxNumber: Scalars["Int"]["output"];
  min: Scalars["Int"]["output"];
  minNumber: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type CellTemperatureInfoQuery = {
  __typename?: "CellTemperatureInfoQuery";
  current?: Maybe<CellTemperatureInfoMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<CellTemperatureInfoMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<CellTemperatureInfoMessage>;
};

export type CellTemperatureInfoQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type CellTemperatureInfoQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type CellTemperaturesMessage = {
  __typename?: "CellTemperaturesMessage";
  sensorCount: Scalars["Int"]["output"];
  temperatures: Scalars["JSONObject"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type CellTemperaturesQuery = {
  __typename?: "CellTemperaturesQuery";
  current?: Maybe<CellTemperaturesMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<CellTemperaturesMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<CellTemperaturesMessage>;
};

export type CellTemperaturesQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type CellTemperaturesQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type CellVoltageMinMaxMessage = {
  __typename?: "CellVoltageMinMaxMessage";
  max: Scalars["Float"]["output"];
  maxCellNumber: Scalars["Int"]["output"];
  min: Scalars["Float"]["output"];
  minCellNumber: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type CellVoltageMinMaxQuery = {
  __typename?: "CellVoltageMinMaxQuery";
  current?: Maybe<CellVoltageMinMaxMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<CellVoltageMinMaxMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<CellVoltageMinMaxMessage>;
};

export type CellVoltageMinMaxQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type CellVoltageMinMaxQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type CellVoltagesMessage = {
  __typename?: "CellVoltagesMessage";
  timestamp: Scalars["DateTime"]["output"];
  voltages: Scalars["JSONObject"]["output"];
};

export type CellVoltagesQuery = {
  __typename?: "CellVoltagesQuery";
  current?: Maybe<CellVoltagesMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<CellVoltagesMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<CellVoltagesMessage>;
};

export type CellVoltagesQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type CellVoltagesQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type Characteristics = {
  __typename?: "Characteristics";
  deviceCharacteristics: DeviceCharacteristics;
  vehicleCharacteristics: VehicleCharacteristics;
};

export type ChargerControlMessage = {
  __typename?: "ChargerControlMessage";
  controlMode: ControlMode;
  controlOutput: ControlOutput;
  maxChargingCurrent: Scalars["Float"]["output"];
  maxChargingVoltage: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type ChargerControlQuery = {
  __typename?: "ChargerControlQuery";
  current?: Maybe<ChargerControlMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<ChargerControlMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<ChargerControlMessage>;
};

export type ChargerControlQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type ChargerControlQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export enum ChargerFaultStatus {
  Fault = "FAULT",
  Ok = "OK",
  Unknown = "UNKNOWN",
}

export type ChargerStatusMessage = {
  __typename?: "ChargerStatusMessage";
  communicationStatus: ChargerFaultStatus;
  hardwareFault: ChargerFaultStatus;
  inputVoltageFault: ChargerFaultStatus;
  outputCurrent: Scalars["Float"]["output"];
  outputVoltage: Scalars["Float"]["output"];
  startupStatus: ChargerFaultStatus;
  temperatureFault: ChargerFaultStatus;
  timestamp: Scalars["DateTime"]["output"];
};

export type ChargerStatusQuery = {
  __typename?: "ChargerStatusQuery";
  current?: Maybe<ChargerStatusMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<ChargerStatusMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<ChargerStatusMessage>;
};

export type ChargerStatusQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type ChargerStatusQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type ConnectivityVitalMessage = {
  __typename?: "ConnectivityVitalMessage";
  /**
   * Number of times the device attempted to connect to the server
   * before successfully doing so and publishing this message.
   */
  connectionAttempts: Scalars["Int"]["output"];
  /** SIM-card ICCID number. */
  iccid: Iccid;
  /** Number of modem restarts since last boot. */
  modemRestarts: Scalars["Int"]["output"];
  /** Network operator name. */
  operatorName: Scalars["String"]["output"];
  /** The current radio technology used, i.e. GSM, LTE, or other. */
  radioAccessTechnology: RadioAccessTechnology;
  /**
   * A 0-100 value indicating signal quality.
   * Defined as the inverse of Bit-Error-Rate.
   */
  signalQuality: Scalars["Int"]["output"];
  /** Signal strength percentage. */
  signalStrength: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type ConnectivityVitalQuery = {
  __typename?: "ConnectivityVitalQuery";
  current?: Maybe<ConnectivityVitalMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<ConnectivityVitalMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<ConnectivityVitalMessage>;
};

export type ConnectivityVitalQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type ConnectivityVitalQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export enum ControlMode {
  Charging = "CHARGING",
  Heating = "HEATING",
  Unknown = "UNKNOWN",
}

export enum ControlOutput {
  AllowChargingAndHeating = "ALLOW_CHARGING_AND_HEATING",
  BatteryProtectionStop = "BATTERY_PROTECTION_STOP",
  Unknown = "UNKNOWN",
}

export type Customer = {
  __typename?: "Customer";
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export type CustomerInput = {
  emailAddress?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type Device = {
  __typename?: "Device";
  alerts: Array<Alert>;
  /** The set of capabilites (or features) that the device supports. */
  capabilities: Array<DeviceCapability>;
  createdAt: Scalars["DateTime"]["output"];
  eventLog: Array<EventLog>;
  /** Firmware version of the MCU (nRF, telematic unit) */
  firmwareVersion?: Maybe<Scalars["String"]["output"]>;
  hwVersion: Scalars["String"]["output"];
  iccid?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["DeviceId"]["output"];
  imei?: Maybe<Scalars["String"]["output"]>;
  /** Returns the oldest bulk OTA update for the device which has a in_progress count > 0 */
  inProgressBulkOtaUpdate?: Maybe<BulkOperation>;
  /** Returns the current in_progress OTA update for the device if any */
  inProgressOtaUpdate?: Maybe<DeviceOtaUpdate>;
  /**
   * Returns the last device request for the given characteristic.
   *
   * Use this to get the current status of any device request (lock/unlock, etc.)
   * in cases where you don't care about a specific request ID.
   */
  lastDeviceRequest?: Maybe<DeviceRequest>;
  richId: RichDeviceId;
  /**
   * Status of the device.
   * Returns null if no recent system vital message was found/sent by the device.
   */
  status?: Maybe<DeviceStatus>;
  /** Firmware version of the VCU (STM, vehicle control unit) */
  vcuVersion?: Maybe<Scalars["String"]["output"]>;
  vehicle?: Maybe<Vehicle>;
};

export type DeviceEventLogArgs = {
  from: Scalars["DateTime"]["input"];
  limit: Scalars["Int"]["input"];
  to: Scalars["DateTime"]["input"];
};

export type DeviceLastDeviceRequestArgs = {
  characteristicId: Scalars["Int"]["input"];
};

export enum DeviceCapability {
  /** Dump device system logs. */
  DumpLogs = "DUMP_LOGS",
  /** Over-The-Air updates. */
  Ota = "OTA",
  /** Remote reboot. */
  Reboot = "REBOOT",
}

export type DeviceCharacteristics = {
  __typename?: "DeviceCharacteristics";
  boot: BootQuery;
  connectivity: ConnectivityVitalQuery;
  geolocation: GeoLocationQuery;
  heartbeat: HeartbeatQuery;
  log: LogQuery;
  power: PowerVitalQuery;
  status?: Maybe<DeviceStatus>;
  system: SystemVitalQuery;
  temperature: TemperatureQuery;
};

export type DeviceOtaUpdate = {
  __typename?: "DeviceOtaUpdate";
  attempts: Scalars["Int"]["output"];
  created: Scalars["DateTime"]["output"];
  device: Device;
  fromVersion?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UpdateId"]["output"];
  otaUpdateId: Scalars["OtaUpdateId"]["output"];
  progress: Scalars["Int"]["output"];
  status: DeviceOtaUpdateStatus;
  statusReason?: Maybe<DeviceOtaUpdateStatusReason>;
  toVersion: Scalars["String"]["output"];
  updated?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum DeviceOtaUpdateStatus {
  /** Update cancelled by user */
  Cancelled = "CANCELLED",
  /** Update completed successfully */
  Completed = "COMPLETED",
  /** The update failed */
  Failed = "FAILED",
  /** Update in progress */
  InProgress = "IN_PROGRESS",
  /** Update not yet processed */
  Pending = "PENDING",
}

export enum DeviceOtaUpdateStatusReason {
  /** Update does not fit in the devices flash memory */
  ImageTooLarge = "IMAGE_TOO_LARGE",
  /** Update failed too many times */
  MaxRetriesExceeded = "MAX_RETRIES_EXCEEDED",
  /** The device has been sent an update for a target it does not know about */
  UnknownTarget = "UNKNOWN_TARGET",
  /** Unspecified reason */
  Unspecified = "UNSPECIFIED",
}

export type DeviceProvisionRequest = {
  deviceId: Scalars["DeviceId"]["input"];
  encryptionMethod: Scalars["String"]["input"];
  psk: Scalars["String"]["input"];
};

export type DeviceRequest = {
  __typename?: "DeviceRequest";
  characteristicId: Scalars["Int"]["output"];
  created: Scalars["DateTime"]["output"];
  device: Device;
  expires?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["RequestId"]["output"];
  retries: Scalars["Int"]["output"];
  status: DeviceRequestStatus;
  updated?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum DeviceRequestStatus {
  /** Request cancelled by user */
  Cancelled = "CANCELLED",
  /** Request completed successfully */
  Completed = "COMPLETED",
  /** Request expired, status no longer available */
  Expired = "EXPIRED",
  /** The request could not be prepared for sending (e.g. unparsable payload) */
  FailedBadRequest = "FAILED_BAD_REQUEST",
  /** Response from device was not what we expected. Either unparsable payload or wrong characteristic id. */
  FailedBadResponse = "FAILED_BAD_RESPONSE",
  /** The request was rejected by the device (in a state where it cannot accept the request) */
  FailedDeviceReject = "FAILED_DEVICE_REJECT",
  /** The device did not respond to the request after the configured number of retries. */
  FailedMaxRetriesExceeded = "FAILED_MAX_RETRIES_EXCEEDED",
  /** Request not yet processed */
  Pending = "PENDING",
}

/** Device status */
export type DeviceStatus = {
  __typename?: "DeviceStatus";
  status: DeviceStatusLabel;
  timestamp: Scalars["DateTime"]["output"];
};

/** Label for device status */
export enum DeviceStatusLabel {
  Offline = "OFFLINE",
  Online = "ONLINE",
}

/** Filter selection for device status */
export enum DeviceStatusSelection {
  Offline = "OFFLINE",
  Online = "ONLINE",
  Unknown = "UNKNOWN",
}

export enum DfuHardware {
  Orange = "ORANGE",
  Unknown = "UNKNOWN",
}

export type DfuPackage = {
  __typename?: "DfuPackage";
  /** Returns the timestamp (UTC) when this package was created. */
  created: Scalars["DateTime"]["output"];
  /** Returns the package description, intended for release notes and similar. */
  description: Scalars["String"]["output"];
  /** Returns the number of devices currently using the target+version of this package. */
  devicesInUse: Scalars["Int"]["output"];
  /**
   * Filesize of the package (in bytes).
   *
   * Note that this is the size of the package (ie. an entity that contains multiple things)
   * not the actual number of bytes that will be sent to a device during update.
   */
  filesize: Scalars["Int"]["output"];
  /** Returns the hardware id for which this package is intended */
  hardware: DfuHardware;
  /** Returns a semantic version requirement for the hardware. */
  hardwareVersionRequirement: Scalars["String"]["output"];
  /** Returns the id of the package. */
  id: Scalars["OtaUpdateId"]["output"];
  /** Returns the slug of the package. */
  slug: Scalars["String"]["output"];
  /** Returns the status of the package */
  status: OtaUpdateStatus;
  /** Returns the target that is updated by this package. */
  target: DfuTarget;
  /** Returns an optional semantic version requirement for the target. */
  targetVersionRequirement?: Maybe<Scalars["String"]["output"]>;
  /** Returns the version of the package. */
  version: Scalars["String"]["output"];
};

export enum DfuTarget {
  Application = "APPLICATION",
  Unknown = "UNKNOWN",
  Vcu = "VCU",
}

export type EndUser = {
  __typename?: "EndUser";
  characteristics: Characteristics;
  userId: Scalars["UserId"]["output"];
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars["VehicleId"]["output"]>;
};

export type EstimatedDailyDistanceMessage = {
  __typename?: "EstimatedDailyDistanceMessage";
  data: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type EstimatedDailyDistanceQuery = {
  __typename?: "EstimatedDailyDistanceQuery";
  current?: Maybe<EstimatedDailyDistanceMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<EstimatedDailyDistanceMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<EstimatedDailyDistanceMessage>;
};

export type EstimatedDailyDistanceQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type EstimatedDailyDistanceQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type EstimatedDistanceMessage = {
  __typename?: "EstimatedDistanceMessage";
  data: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type EstimatedDistanceQuery = {
  __typename?: "EstimatedDistanceQuery";
  current?: Maybe<EstimatedDistanceMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<EstimatedDistanceMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<EstimatedDistanceMessage>;
};

export type EstimatedDistanceQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type EstimatedDistanceQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export enum EventLevel {
  Error = "ERROR",
  Info = "INFO",
  Warning = "WARNING",
}

export type EventLog = {
  __typename?: "EventLog";
  /** The (optional) alert id this event is associated with. */
  alertId?: Maybe<Scalars["AlertId"]["output"]>;
  /** Data necessary to display the event -- business rule specific */
  data: Scalars["JSON"]["output"];
  /** The (optional) device id this event is associated with. */
  deviceId?: Maybe<Scalars["DeviceId"]["output"]>;
  /** Event key (unique identifier in combination with `event_type`) -- business rule specific */
  eventKey: Scalars["String"]["output"];
  /** Event type (unique identifier in combination with `event_key`) -- business rule specific */
  eventType: Scalars["String"]["output"];
  /** Level of the event. */
  level: EventLevel;
  /** The timestamp of the event. */
  timestamp: Scalars["DateTime"]["output"];
};

/**
 * Factory ID part of a [DeviceId].
 *
 * This defines how the Factory ID part of Elevate [DeviceId]s should be interpreted within the
 * context of Epsilon. The variant corresponds to the location where the device was provisioned.
 */
export enum FactoryId {
  Foab = "FOAB",
  JcPcba = "JC_PCBA",
  TtcGoteborg = "TTC_GOTEBORG",
  TtcShenzen = "TTC_SHENZEN",
  Unknown = "UNKNOWN",
}

export type ForeignDeviceProvisionRequest = {
  factoryId: FactoryId;
  foreignId: Scalars["String"]["input"];
  hardwareVersion: Scalars["SemVer"]["input"];
  objectId: ObjectId;
};

export type GeoLocationMessage = {
  __typename?: "GeoLocationMessage";
  /** Altitude in meters */
  altitude: Scalars["Float"]["output"];
  /**
   * Signal to noise ratio in dBHz
   *
   * C/No is the ratio of carrier power C to the noise power N0 mixed
   * with the signal, in a 1Hz bandwidth.
   * See [Wikipedia] for more information.
   *
   * [Wikipedia]: https://en.wikipedia.org/wiki/Carrier-to-noise_ratio
   */
  cN0Max: Scalars["Int"]["output"];
  /** Course as 0-360 degrees */
  directionDegrees: Scalars["Float"]["output"];
  /**
   * Horizontal dilution of precision
   *
   * The lowest value is 0 and is the most precise. Values above 5 are considered poor.
   * See [Wikipedia] for more information.
   *
   * [Wikipedia]: https://en.wikipedia.org/wiki/Dilution_of_precision_(navigation)
   */
  hdop: Scalars["Float"]["output"];
  /** Latitude in degrees */
  latitude: Scalars["Float"]["output"];
  /** Longitude in degrees */
  longitude: Scalars["Float"]["output"];
  /** Number of satellites used in fix */
  satellitesUsed: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  /**
   * Vertical dilution of precision
   *
   * The lowest value is 0 and is the most precise. Values above 5 are considered poor.
   * See [Wikipedia] for more information.
   *
   * [Wikipedia]: https://en.wikipedia.org/wiki/Dilution_of_precision_(navigation)
   */
  vdop: Scalars["Float"]["output"];
  /** Velocity in km/h */
  velocity: Scalars["Float"]["output"];
};

export type GeoLocationQuery = {
  __typename?: "GeoLocationQuery";
  current?: Maybe<GeoLocationMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<GeoLocationMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<GeoLocationMessage>;
};

export type GeoLocationQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type GeoLocationQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

/** Represents the geolocation of a device in a specific time */
export type GeoPoint = {
  __typename?: "GeoPoint";
  bearing: Scalars["Float"]["output"];
  lat: Scalars["Float"]["output"];
  lon: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type HeartbeatMessage = {
  __typename?: "HeartbeatMessage";
  errors: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type HeartbeatQuery = {
  __typename?: "HeartbeatQuery";
  current?: Maybe<HeartbeatMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<HeartbeatMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<HeartbeatMessage>;
};

export type HeartbeatQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type HeartbeatQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type Iccid = {
  __typename?: "Iccid";
  account: Scalars["Int"]["output"];
  country: Scalars["Int"]["output"];
  issuer: Scalars["Int"]["output"];
};

export type IgnitionMessage = {
  __typename?: "IgnitionMessage";
  /** `true` if vehicle ignition is on. */
  ignitionOn: Scalars["Boolean"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type IgnitionQuery = {
  __typename?: "IgnitionQuery";
  current?: Maybe<IgnitionMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<IgnitionMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<IgnitionMessage>;
};

export type IgnitionQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type IgnitionQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type LogMessage = {
  __typename?: "LogMessage";
  log: Array<Scalars["Int"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
};

export type LogQuery = {
  __typename?: "LogQuery";
  current?: Maybe<LogMessage>;
  historical: Array<Maybe<LogMessage>>;
};

export type LogQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type MotorControl1Message = {
  __typename?: "MotorControl1Message";
  maxChargeCurrent: Scalars["Float"]["output"];
  maxChargePhaseCurrent: Scalars["Float"]["output"];
  maxDischargeCurrent: Scalars["Float"]["output"];
  maxDischargePhaseCurrent: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type MotorControl1Query = {
  __typename?: "MotorControl1Query";
  current?: Maybe<MotorControl1Message>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<MotorControl1Message>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<MotorControl1Message>;
};

export type MotorControl1QueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type MotorControl1QueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type MotorControl2Message = {
  __typename?: "MotorControl2Message";
  maxSpeed: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  torqueCoefficient: Scalars["Int"]["output"];
  undervoltage: Scalars["Float"]["output"];
};

export type MotorControl2Query = {
  __typename?: "MotorControl2Query";
  current?: Maybe<MotorControl2Message>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<MotorControl2Message>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<MotorControl2Message>;
};

export type MotorControl2QueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type MotorControl2QueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export enum MotorStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Unknown = "UNKNOWN",
}

export type MotorStatus1Message = {
  __typename?: "MotorStatus1Message";
  acceleratorPedalFault: MotorStatus;
  antiTheftAlarmSignal: MotorStatus;
  antiTheftStatus: MotorStatus;
  brakeFailure: MotorStatus;
  controllerOvertemperature: MotorStatus;
  controllerTemperature: Scalars["Int"]["output"];
  currentProtectionRestart: MotorStatus;
  lineCurrentZeroPointFault: MotorStatus;
  mosfetLowerBridgeFailure: MotorStatus;
  mosfetUpperBridgeFailure: MotorStatus;
  motorHallFault: MotorStatus;
  motorOverheating: MotorStatus;
  motorPhaseFailure: MotorStatus;
  motorStall: MotorStatus;
  motorTemperature: Scalars["Int"]["output"];
  overvoltageFault: MotorStatus;
  peakLineCurrentProtection: MotorStatus;
  phaseCurrentOvercurrent: MotorStatus;
  phaseCurrentOverflow: MotorStatus;
  phaseCurrentZeroPointFault: MotorStatus;
  phaseShortCircuitFault: MotorStatus;
  timestamp: Scalars["DateTime"]["output"];
  undervoltageFault: MotorStatus;
  voltageFault: MotorStatus;
};

export type MotorStatus1Query = {
  __typename?: "MotorStatus1Query";
  current?: Maybe<MotorStatus1Message>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<MotorStatus1Message>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<MotorStatus1Message>;
};

export type MotorStatus1QueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type MotorStatus1QueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type MotorStatus2Message = {
  __typename?: "MotorStatus2Message";
  phaseCurrent: Scalars["Float"]["output"];
  rpm: Scalars["Int"]["output"];
  throttle: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  torque: Scalars["Float"]["output"];
};

export type MotorStatus2Query = {
  __typename?: "MotorStatus2Query";
  current?: Maybe<MotorStatus2Message>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<MotorStatus2Message>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<MotorStatus2Message>;
};

export type MotorStatus2QueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type MotorStatus2QueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type MotorStatus3Message = {
  __typename?: "MotorStatus3Message";
  busCurrent: Scalars["Float"]["output"];
  busVoltage: Scalars["Float"]["output"];
  cycleCount: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type MotorStatus3Query = {
  __typename?: "MotorStatus3Query";
  current?: Maybe<MotorStatus3Message>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<MotorStatus3Message>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<MotorStatus3Message>;
};

export type MotorStatus3QueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type MotorStatus3QueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type Mutation = {
  __typename?: "Mutation";
  /** Set status of the dfu package to Created */
  activateDfuPackage: Scalars["Boolean"]["output"];
  /** Set status of multiple dfu packages to Created */
  bulkActivateDfuPackages: Scalars["Boolean"]["output"];
  /**
   * Cancels all matching and eligible (pending, not failed etc.) device requests for a bulk operation.
   *
   * Returns the number of requests that were cancelled.
   */
  bulkCancelDeviceRequest: Scalars["Int"]["output"];
  /**
   * Cancels all matching and eligible (pending, not failed etc.) OTA updates for a bulk operation.
   *
   * Returns the number of OTA updates that were cancelled.
   */
  bulkCancelOtaUpdate: Scalars["Int"]["output"];
  /** Set status of multiple dfu packages to Inactive */
  bulkDeactivateDfuPackages: Scalars["Boolean"]["output"];
  /**
   * Deletes dfu packages with the given ids
   *
   * If one package or more are currently in use, the bulk delete won't happen at all and an error will be returned
   */
  bulkDeleteDfuPackages: Scalars["Boolean"]["output"];
  bulkDeleteUsers: Scalars["Boolean"]["output"];
  bulkDeleteVehicles: Scalars["Boolean"]["output"];
  /** Creates a bulk operation for OTA updating a list of devices. */
  bulkOtaUpdate: Scalars["OperationId"]["output"];
  /** Creates a bulk operation for rebooting a list of devices. */
  bulkReboot: Scalars["OperationId"]["output"];
  /**
   * Retries all matching and eligible (failed, cancelled, not pending etc.) device requests for a bulk operation.
   *
   * Returns the number of requests that were retried.
   */
  bulkRetryDeviceRequest: Scalars["Int"]["output"];
  /**
   * Retries all matching and eligible (failed, cancelled, not pending etc.) OTA updates for a bulk operation.
   *
   * Returns the number of OTA updates that were retried.
   */
  bulkRetryOtaUpdate: Scalars["Int"]["output"];
  bulkUpdateUsersTenant: Scalars["Boolean"]["output"];
  /** Update the tenant assigned to a list of vehicles */
  bulkUpdateVehiclesTenant: Array<Vehicle>;
  cancelDeviceRequest: Scalars["Boolean"]["output"];
  changePassword: Scalars["Boolean"]["output"];
  /** confirm the 2FA setup with a valid TOTP code generated by the user */
  confirm2FaSetup: Scalars["Boolean"]["output"];
  /**
   * Confirms the dfu package with the given id, thus making it available for deploying to devices.
   *
   * This requires a previous call to `upload_dfu_package_draft`.
   */
  confirmDfuPackageDraft: Scalars["Boolean"]["output"];
  createTenant: Tenant;
  /** The username is the email address */
  createUser: User;
  createVehicle: Scalars["VehicleId"]["output"];
  /** Set status of the dfu package to Inactive */
  deactivateDfuPackage: Scalars["Boolean"]["output"];
  /**
   * Deletes the dfu package with the given id
   *
   * If the package is currently in use, it won't be deleted, an error will be returned
   */
  deleteDfuPackage: Scalars["Boolean"]["output"];
  deleteTenant: Scalars["Boolean"]["output"];
  deleteUser: Scalars["Boolean"]["output"];
  deleteVehicle: Scalars["Boolean"]["output"];
  disable2Fa: Scalars["Boolean"]["output"];
  /** initialize a setup for 2FA */
  init2FaSetup: TotpSetupResult;
  provisionDevice: Scalars["DeviceId"]["output"];
  provisionForeignDevice: Scalars["DeviceId"]["output"];
  reboot: Scalars["RequestId"]["output"];
  removeTenantImage: Tenant;
  requestLog: Scalars["RequestId"]["output"];
  requestPasswordReset: Scalars["PasswordResetToken"]["output"];
  tenantImageUpload: Tenant;
  updateTenant: Tenant;
  updateUser: User;
  updateUserVehicle: Scalars["Boolean"]["output"];
  updateVehicle: Vehicle;
  /**
   * Uploads an elevate package to create a DFU package draft.
   *
   * This call will return package information.
   * It will need to be confirmed by calling `confirm_dfu_package_draft` before it can be deployed to devices.
   */
  uploadDfuPackageDraft: DfuPackage;
};

export type MutationActivateDfuPackageArgs = {
  id: Scalars["OtaUpdateId"]["input"];
};

export type MutationBulkActivateDfuPackagesArgs = {
  ids: Array<Scalars["OtaUpdateId"]["input"]>;
};

export type MutationBulkCancelDeviceRequestArgs = {
  deviceIds: Array<Scalars["DeviceId"]["input"]>;
  operationId: Scalars["OperationId"]["input"];
};

export type MutationBulkCancelOtaUpdateArgs = {
  deviceIds: Array<Scalars["DeviceId"]["input"]>;
  operationId: Scalars["OperationId"]["input"];
};

export type MutationBulkDeactivateDfuPackagesArgs = {
  ids: Array<Scalars["OtaUpdateId"]["input"]>;
};

export type MutationBulkDeleteDfuPackagesArgs = {
  ids: Array<Scalars["OtaUpdateId"]["input"]>;
};

export type MutationBulkDeleteUsersArgs = {
  userIds: Array<Scalars["UserId"]["input"]>;
};

export type MutationBulkDeleteVehiclesArgs = {
  vehicleIds: Array<Scalars["VehicleId"]["input"]>;
};

export type MutationBulkOtaUpdateArgs = {
  deviceIds: Array<Scalars["DeviceId"]["input"]>;
  otaUpdateId: Scalars["OtaUpdateId"]["input"];
};

export type MutationBulkRebootArgs = {
  deviceIds: Array<Scalars["DeviceId"]["input"]>;
};

export type MutationBulkRetryDeviceRequestArgs = {
  deviceIds: Array<Scalars["DeviceId"]["input"]>;
  operationId: Scalars["OperationId"]["input"];
};

export type MutationBulkRetryOtaUpdateArgs = {
  deviceIds: Array<Scalars["DeviceId"]["input"]>;
  operationId: Scalars["OperationId"]["input"];
};

export type MutationBulkUpdateUsersTenantArgs = {
  tenantSlug: Scalars["String"]["input"];
  userIds: Array<Scalars["UserId"]["input"]>;
};

export type MutationBulkUpdateVehiclesTenantArgs = {
  tenantSlug: Scalars["String"]["input"];
  vehicleIds: Array<Scalars["VehicleId"]["input"]>;
};

export type MutationCancelDeviceRequestArgs = {
  id: Scalars["RequestId"]["input"];
};

export type MutationChangePasswordArgs = {
  newPassword: Scalars["String"]["input"];
  oldPassword: Scalars["String"]["input"];
};

export type MutationConfirm2FaSetupArgs = {
  code: Scalars["String"]["input"];
};

export type MutationConfirmDfuPackageDraftArgs = {
  id: Scalars["OtaUpdateId"]["input"];
};

export type MutationCreateTenantArgs = {
  contactPerson?: InputMaybe<Scalars["String"]["input"]>;
  emailAddress?: InputMaybe<Scalars["String"]["input"]>;
  imageFile?: InputMaybe<Scalars["Upload"]["input"]>;
  name: Scalars["String"]["input"];
  parentId: Scalars["TenantId"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  website?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateUserArgs = {
  fullName: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  role: UserRole;
  tenantSlug: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
  vehicle?: InputMaybe<Scalars["VehicleId"]["input"]>;
};

export type MutationCreateVehicleArgs = {
  battery1Sn?: InputMaybe<Scalars["String"]["input"]>;
  battery2Sn?: InputMaybe<Scalars["String"]["input"]>;
  controllerSn?: InputMaybe<Scalars["String"]["input"]>;
  customer?: InputMaybe<CustomerInput>;
  deviceId?: InputMaybe<Scalars["DeviceId"]["input"]>;
  model: VehicleModel;
  name?: InputMaybe<Scalars["String"]["input"]>;
  productionDate?: InputMaybe<Scalars["NaiveDate"]["input"]>;
  tenantSlug?: InputMaybe<Scalars["String"]["input"]>;
  vinNo: Scalars["String"]["input"];
};

export type MutationDeactivateDfuPackageArgs = {
  id: Scalars["OtaUpdateId"]["input"];
};

export type MutationDeleteDfuPackageArgs = {
  id: Scalars["OtaUpdateId"]["input"];
};

export type MutationDeleteTenantArgs = {
  tenantId: Scalars["TenantId"]["input"];
};

export type MutationDeleteUserArgs = {
  userId: Scalars["UserId"]["input"];
};

export type MutationDeleteVehicleArgs = {
  vehicleId: Scalars["VehicleId"]["input"];
};

export type MutationDisable2FaArgs = {
  password: Scalars["String"]["input"];
};

export type MutationProvisionDeviceArgs = {
  deviceProvisionRequest: DeviceProvisionRequest;
};

export type MutationProvisionForeignDeviceArgs = {
  request: ForeignDeviceProvisionRequest;
};

export type MutationRebootArgs = {
  id: Scalars["DeviceId"]["input"];
};

export type MutationRemoveTenantImageArgs = {
  tenantId: Scalars["TenantId"]["input"];
};

export type MutationRequestLogArgs = {
  id: Scalars["DeviceId"]["input"];
};

export type MutationRequestPasswordResetArgs = {
  userId: Scalars["UserId"]["input"];
};

export type MutationTenantImageUploadArgs = {
  file: Scalars["Upload"]["input"];
  tenantId: Scalars["TenantId"]["input"];
};

export type MutationUpdateTenantArgs = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  optionalTenantValues: TenantNullableValues;
  parentId?: InputMaybe<Scalars["TenantId"]["input"]>;
  tenantId: Scalars["TenantId"]["input"];
};

export type MutationUpdateUserArgs = {
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  optionalUserValues: UserNullableValues;
  role?: InputMaybe<UserRole>;
  tenantSlug?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["UserId"]["input"];
};

export type MutationUpdateUserVehicleArgs = {
  userId: Scalars["UserId"]["input"];
  vehicleId?: InputMaybe<Scalars["VehicleId"]["input"]>;
};

export type MutationUpdateVehicleArgs = {
  optionalVehicleValues: VehicleNullableValues;
  vehicleId: Scalars["VehicleId"]["input"];
};

export type MutationUploadDfuPackageDraftArgs = {
  package: Scalars["Upload"]["input"];
};

/**
 * Object ID part of a [DeviceId].
 *
 * This defines how the Object ID part of Elevate [DeviceId]s should be interpreted within the
 * context of Epsilon.
 */
export enum ObjectId {
  Orange = "ORANGE",
  Unknown = "UNKNOWN",
}

export enum OperatingMode {
  Hf = "HF",
  Lf = "LF",
  LowVoltage = "LOW_VOLTAGE",
}

export enum OtaUpdateStatus {
  Created = "CREATED",
  Draft = "DRAFT",
  Inactive = "INACTIVE",
}

export type PowerVitalMessage = {
  __typename?: "PowerVitalMessage";
  externalBattery?: Maybe<Battery>;
  internalBattery: Battery;
  timestamp: Scalars["DateTime"]["output"];
};

export type PowerVitalQuery = {
  __typename?: "PowerVitalQuery";
  current?: Maybe<PowerVitalMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<PowerVitalMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<PowerVitalMessage>;
};

export type PowerVitalQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type PowerVitalQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type Query = {
  __typename?: "Query";
  /**
   * Returns the list of device OTA updates for a bulk operation.
   *
   * If the `operation_id` is not found, an empty list is returned.
   */
  bulkDeviceOtaUpdates: Array<DeviceOtaUpdate>;
  /**
   * Returns the list of device requests for a bulk operation.
   *
   * If the `operation_id` is not found, an empty list is returned.
   */
  bulkDeviceRequests: Array<DeviceRequest>;
  /**
   * Returns a bulk operation for a given `operation_id`.
   *
   * This is a query that consolidates the results of two queries:
   * - bulk device requests
   * - bulk device ota updates
   */
  bulkOperation?: Maybe<BulkOperation>;
  /**
   * Returns a list of bulk operations created between dates.
   *
   * This is a query that consolidates the results of two queries:
   * - bulk device requests
   * - bulk device ota updates
   */
  bulkOperations: Array<BulkOperation>;
  /**
   * Return characteristics collected by a device
   * Return both device and vehicle characteristics
   */
  characteristics: Characteristics;
  /** Get the current end-user. */
  currentEndUser: EndUser;
  device: Device;
  /** Returns devices matching the given filters, used in listing devices in the UI */
  devicePreviews: Array<Device>;
  deviceRequest: DeviceRequest;
  devices: Array<Device>;
  /** Returns the dfu package with the given id. */
  dfuPackage: DfuPackage;
  endUserById: EndUser;
  endUserByVehicleId?: Maybe<EndUser>;
  /** List all end users. */
  endUsers: Array<EndUser>;
  exportDeviceEventLogs: Scalars["String"]["output"];
  /**
   * Return event logs for a vehicle in a CSV format
   *
   * The from date is inclusive, the to date is exclusive.
   * The response is base64 encoded.
   */
  exportVehicleEventLogs: Scalars["String"]["output"];
  /** Return a map of the distinct hardware versions and their count */
  listHwVersions: Array<Scalars["String"]["output"]>;
  /** get the information for the currently logged in user */
  me: User;
  /** Get the roles of the current user. */
  ownRoles: Array<Scalars["String"]["output"]>;
  /**
   * Returns a single SIM with the given ICCID.
   *
   * # Arguments
   * * `name` - A string representing the SIM's ICCID
   *
   * # Notes
   * Will hit several endoints of the SIM provides API and combine the data into a single object.
   */
  sim?: Maybe<Sim>;
  /** Return historical sim quota data for the given iccid between given timestamps */
  simData: Array<SimData>;
  /** Return historical sim quota data for the given device between given timestamps */
  simDataForDevice: Array<SimData>;
  /**
   * Returns a list of dfu packages for the given target.
   * Filter on the status if a status is passed. Otherwise don't filter on the status at all.
   */
  targetDfuPackages: Array<DfuPackage>;
  /** get tenant information */
  tenant: Tenant;
  /** list all available (to logged in user) tenants */
  tenants: Array<Tenant>;
  unassingedDevices: Array<Device>;
  user: User;
  userRoles: Array<UserRole>;
  users: Array<User>;
  vehicle: Vehicle;
  vehiclePreviews: Array<VehiclePreview>;
  vehicles: Array<Vehicle>;
};

export type QueryBulkDeviceOtaUpdatesArgs = {
  operationId: Scalars["OperationId"]["input"];
};

export type QueryBulkDeviceRequestsArgs = {
  operationId: Scalars["OperationId"]["input"];
};

export type QueryBulkOperationArgs = {
  operationId: Scalars["OperationId"]["input"];
};

export type QueryBulkOperationsArgs = {
  from: Scalars["DateTime"]["input"];
  to: Scalars["DateTime"]["input"];
};

export type QueryCharacteristicsArgs = {
  deviceId: Scalars["DeviceId"]["input"];
};

export type QueryDeviceArgs = {
  id: Scalars["DeviceId"]["input"];
};

export type QueryDevicePreviewsArgs = {
  fwVersion: Array<Scalars["String"]["input"]>;
  hwVersion: Array<Scalars["String"]["input"]>;
  status: Array<DeviceStatusSelection>;
  tenantSlugs: Array<InputMaybe<Scalars["String"]["input"]>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryDeviceRequestArgs = {
  requestId: Scalars["RequestId"]["input"];
};

export type QueryDfuPackageArgs = {
  id: Scalars["OtaUpdateId"]["input"];
};

export type QueryEndUserByIdArgs = {
  id: Scalars["UserId"]["input"];
};

export type QueryEndUserByVehicleIdArgs = {
  id: Scalars["VehicleId"]["input"];
};

export type QueryExportDeviceEventLogsArgs = {
  deviceId: Scalars["DeviceId"]["input"];
  from: Scalars["DateTime"]["input"];
  limit: Scalars["Int"]["input"];
  to: Scalars["DateTime"]["input"];
};

export type QueryExportVehicleEventLogsArgs = {
  from: Scalars["DateTime"]["input"];
  limit: Scalars["Int"]["input"];
  to: Scalars["DateTime"]["input"];
  vehicleId: Scalars["VehicleId"]["input"];
};

export type QuerySimArgs = {
  iccid: Scalars["String"]["input"];
};

export type QuerySimDataArgs = {
  from: Scalars["DateTime"]["input"];
  iccid: Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  to: Scalars["DateTime"]["input"];
};

export type QuerySimDataForDeviceArgs = {
  deviceId: Scalars["DeviceId"]["input"];
  from: Scalars["DateTime"]["input"];
  limit: Scalars["Int"]["input"];
  to: Scalars["DateTime"]["input"];
};

export type QueryTargetDfuPackagesArgs = {
  status?: InputMaybe<OtaUpdateStatus>;
  target: DfuTarget;
};

export type QueryTenantArgs = {
  id: Scalars["TenantId"]["input"];
};

export type QueryUnassingedDevicesArgs = {
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryUserArgs = {
  id: Scalars["UserId"]["input"];
};

export type QueryUserRolesArgs = {
  id: Scalars["UserId"]["input"];
};

export type QueryVehicleArgs = {
  vehicleId: Scalars["VehicleId"]["input"];
};

export type QueryVehiclePreviewsArgs = {
  alertKeys: Array<Scalars["String"]["input"]>;
  deviceStatus: Array<DeviceStatusSelection>;
  tenantSlugs: Array<InputMaybe<Scalars["String"]["input"]>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  vehicleStatus: Array<VehicleStatusSelection>;
};

export enum RadioAccessTechnology {
  Gsm = "GSM",
  LteCatM1 = "LTE_CAT_M1",
  LteNbIoT = "LTE_NB_IO_T",
  None = "NONE",
  Other = "OTHER",
}

export enum ResetReason {
  AnaDetect = "ANA_DETECT",
  ChipPowerOn = "CHIP_POWER_ON",
  CoreDeepSleep = "CORE_DEEP_SLEEP",
  CoreEfuseCrc = "CORE_EFUSE_CRC",
  CoreMwdt_0 = "CORE_MWDT_0",
  CoreMwdt_1 = "CORE_MWDT_1",
  CorePwrGlitch = "CORE_PWR_GLITCH",
  CoreRtcWdt = "CORE_RTC_WDT",
  CoreSw = "CORE_SW",
  CoreUsbJtag = "CORE_USB_JTAG",
  CoreUsbUart = "CORE_USB_UART",
  CpuLock = "CPU_LOCK",
  CpuMwdt_0 = "CPU_MWDT_0",
  CpuMwdt_1 = "CPU_MWDT_1",
  CpuRtcWdt = "CPU_RTC_WDT",
  CpuSw = "CPU_SW",
  DebugInterface = "DEBUG_INTERFACE",
  GpioWake = "GPIO_WAKE",
  NfcWake = "NFC_WAKE",
  PinReset = "PIN_RESET",
  SoftReset = "SOFT_RESET",
  SysBrownOut = "SYS_BROWN_OUT",
  SysClkGlitch = "SYS_CLK_GLITCH",
  SysRtcWdt = "SYS_RTC_WDT",
  SysSuperWdt = "SYS_SUPER_WDT",
  Unknown = "UNKNOWN",
  VbusWake = "VBUS_WAKE",
  Watchdog = "WATCHDOG",
}

/** An unpacked [DeviceId] with rich detail. */
export type RichDeviceId = {
  __typename?: "RichDeviceId";
  factoryId: FactoryId;
  hardwareVersion: Scalars["SemVer"]["output"];
  objectId: ObjectId;
  provisioningDate?: Maybe<Scalars["NaiveDate"]["output"]>;
  sequenceNumber: Scalars["Int"]["output"];
};

/** The useful SIM struct that combines data from all available endpoints */
export type Sim = {
  __typename?: "Sim";
  activationDate: Scalars["DateTime"]["output"];
  connectionStatus: Scalars["String"]["output"];
  expiryDate: Scalars["DateTime"]["output"];
  iccid: Scalars["String"]["output"];
  ipAddress: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  lastStatusChangeDate: Scalars["DateTime"]["output"];
  location?: Maybe<SimLocation>;
  simStatus: Scalars["String"]["output"];
  totalVolume: Scalars["Float"]["output"];
  volume: Scalars["Float"]["output"];
};

export type SimData = {
  __typename?: "SimData";
  /** The (optional) device id the sim is associated with. */
  deviceId?: Maybe<Scalars["DeviceId"]["output"]>;
  /** SIM ICCID */
  iccid: Scalars["String"]["output"];
  /** Insertion timestamp */
  timestamp: Scalars["DateTime"]["output"];
  /** Total data volume */
  totalVolume: Scalars["Float"]["output"];
  /** Remaining data volume */
  volume: Scalars["Float"]["output"];
};

export type SimLocation = {
  __typename?: "SimLocation";
  countryId: Scalars["String"]["output"];
  countryIsoCode: Scalars["String"]["output"];
  countryName: Scalars["String"]["output"];
  operatorId: Scalars["String"]["output"];
  operatorName: Scalars["String"]["output"];
};

export type SystemVitalMessage = {
  __typename?: "SystemVitalMessage";
  activeApplicationBank: ApplicationBank;
  mode: OperatingMode;
  restarts: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  uptime: Scalars["Int"]["output"];
  versionMap: Scalars["JSONObject"]["output"];
};

export type SystemVitalQuery = {
  __typename?: "SystemVitalQuery";
  current?: Maybe<SystemVitalMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<SystemVitalMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<SystemVitalMessage>;
};

export type SystemVitalQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type SystemVitalQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type TamperMessage = {
  __typename?: "TamperMessage";
  /** Status of the connector tamper sensor. Triggered if e.g. the connector is removed. */
  connector: TamperStatus;
  /** Status of the enclosure tamper sensor. Triggered if e.g. the enclosure is opened. */
  enclosure: TamperStatus;
  timestamp: Scalars["DateTime"]["output"];
};

export type TamperQuery = {
  __typename?: "TamperQuery";
  current?: Maybe<TamperMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<TamperMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<TamperMessage>;
};

export type TamperQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type TamperQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

/** Status of a tamper sensor. */
export enum TamperStatus {
  /** Element is currently not being tampered with. */
  NoTamper = "NO_TAMPER",
  /** Tampering detected. */
  TamperDetected = "TAMPER_DETECTED",
  /** Tamper status is unknown, not implemented, or the sensor does not exist. */
  Unknown = "UNKNOWN",
}

export type TemperatureMessage = {
  __typename?: "TemperatureMessage";
  /** Temperature in Celsius/100 */
  temperature: Scalars["Int"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type TemperatureQuery = {
  __typename?: "TemperatureQuery";
  current?: Maybe<TemperatureMessage>;
  /**
   * Returns all device messages between two timestamps,
   * for a given device and characteristic.
   */
  historical: Array<TemperatureMessage>;
  /**
   * Returns the last device message at a given timestamp or before,
   * for a given device and characteristic.
   *
   * If there is no message at the given timestamp or before, returns `None`.
   */
  last?: Maybe<TemperatureMessage>;
};

export type TemperatureQueryHistoricalArgs = {
  and: Scalars["DateTime"]["input"];
  between: Scalars["DateTime"]["input"];
};

export type TemperatureQueryLastArgs = {
  timestamp: Scalars["DateTime"]["input"];
};

export type Tenant = {
  __typename?: "Tenant";
  assignedUsers: Array<User>;
  assignedVehicles: Array<Vehicle>;
  canBeDeleted: Scalars["Boolean"]["output"];
  contactPerson: Scalars["String"]["output"];
  emailAddress: Scalars["String"]["output"];
  id: Scalars["TenantId"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  parentTenant?: Maybe<Tenant>;
  phoneNumber: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  website: Scalars["String"]["output"];
};

export type TenantNullableValues = {
  contactPerson?: InputMaybe<Scalars["String"]["input"]>;
  emailAddress?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  website?: InputMaybe<Scalars["String"]["input"]>;
};

export type TotpSetupResult = {
  __typename?: "TotpSetupResult";
  qrCode: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type User = {
  __typename?: "User";
  fullName: Scalars["String"]["output"];
  id: Scalars["UserId"]["output"];
  is2FaEnabled: Scalars["Boolean"]["output"];
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  roles: Array<UserRole>;
  tenant: Tenant;
  username: Scalars["String"]["output"];
};

export type UserNullableValues = {
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** All the possible roles a user can have */
export enum UserRole {
  Admin = "ADMIN",
  EndUser = "END_USER",
  Viewer = "VIEWER",
}

export type Vehicle = {
  __typename?: "Vehicle";
  alerts: Array<Alert>;
  battery1Sn?: Maybe<Scalars["String"]["output"]>;
  battery2Sn?: Maybe<Scalars["String"]["output"]>;
  controllerSn?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<Customer>;
  elevateDevice?: Maybe<Device>;
  eventLog: Array<EventLog>;
  id: Scalars["VehicleId"]["output"];
  model: VehicleModel;
  name?: Maybe<Scalars["String"]["output"]>;
  productionDate?: Maybe<Scalars["NaiveDate"]["output"]>;
  /**
   * Status of the vehicle.
   * Returns null if no recent message pertaining motor on/off was found/sent by the device.
   */
  status?: Maybe<VehicleStatus>;
  tenant?: Maybe<Tenant>;
  vinNo: Scalars["String"]["output"];
};

export type VehicleEventLogArgs = {
  from: Scalars["DateTime"]["input"];
  limit: Scalars["Int"]["input"];
  to: Scalars["DateTime"]["input"];
};

/** Vehicle characteristics, most data is from CAN messages from bike ECUs */
export type VehicleCharacteristics = {
  __typename?: "VehicleCharacteristics";
  batteryCapacity: BatteryCapacityQuery;
  batteryState: BatteryStateQuery;
  batteryStatus: BatteryInfoQuery;
  batteryWarning: BatteryWarningQuery;
  bmsCapacity: BmsCapacityQuery;
  bmsCurrent: BmsCurrentQuery;
  bmsMaxTemperature: BmsMaxTemperatureQuery;
  bmsMaxVoltage: BmsMaxVoltageQuery;
  bmsMinTemperature: BmsMinTemperatureQuery;
  bmsMinVoltage: BmsMinVoltageQuery;
  bmsOutputVoltage: BmsOutputVoltageQuery;
  bmsPack: BmsPackQuery;
  bmsProduct: BmsProductQuery;
  bmsRs485Bus: BmsRs485BusQuery;
  bmsRtcTime: BmsRtcTimeQuery;
  bmsSerialNumber: BmsSerialNumberQuery;
  bmsSwitchState: BmsSwitchStateQuery;
  bmsTemperature: BmsTemperatureQuery;
  bmsVoltageInfo: BmsVoltageInfoQuery;
  cellTemperatureInfo: CellTemperatureInfoQuery;
  cellTemperatures: CellTemperaturesQuery;
  cellVoltageMinMax: CellVoltageMinMaxQuery;
  cellVoltages: CellVoltagesQuery;
  chargerControl: ChargerControlQuery;
  chargerStatus: ChargerStatusQuery;
  estimatedDailyDistance: EstimatedDailyDistanceQuery;
  estimatedDistance: EstimatedDistanceQuery;
  ignition: IgnitionQuery;
  motorControl1: MotorControl1Query;
  motorControl2: MotorControl2Query;
  motorStatus1: MotorStatus1Query;
  motorStatus2: MotorStatus2Query;
  motorStatus3: MotorStatus3Query;
  status?: Maybe<VehicleStatus>;
  tamper: TamperQuery;
};

export enum VehicleModel {
  Motorbike = "MOTORBIKE",
  Scooter = "SCOOTER",
  TukTuk = "TUK_TUK",
  TukTuk_5Seats = "TUK_TUK_5_SEATS",
  Unknown = "UNKNOWN",
  W2500GreyVintage = "W2500_GREY_VINTAGE",
  W2500Red = "W2500_RED",
}

export type VehicleNullableValues = {
  battery1Sn?: InputMaybe<Scalars["String"]["input"]>;
  battery2Sn?: InputMaybe<Scalars["String"]["input"]>;
  controllerSn?: InputMaybe<Scalars["String"]["input"]>;
  customer?: InputMaybe<CustomerInput>;
  deviceId?: InputMaybe<Scalars["DeviceId"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  productionDate?: InputMaybe<Scalars["NaiveDate"]["input"]>;
  tenantSlug?: InputMaybe<Scalars["String"]["input"]>;
};

export type VehiclePreview = {
  __typename?: "VehiclePreview";
  alerts: Array<Scalars["String"]["output"]>;
  elevateDeviceId?: Maybe<Scalars["DeviceId"]["output"]>;
  elevateDeviceStatus?: Maybe<DeviceStatus>;
  firmwareVersion?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["VehicleId"]["output"];
  location?: Maybe<GeoPoint>;
  model: VehicleModel;
  name?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<VehicleStatus>;
  tenant?: Maybe<Tenant>;
  timestamp: Scalars["DateTime"]["output"];
  vinNo: Scalars["String"]["output"];
};

/** The vehicle status, depending on the latest data from the device */
export type VehicleStatus = {
  __typename?: "VehicleStatus";
  status: VehicleStatusLabel;
  timestamp?: Maybe<Scalars["DateTime"]["output"]>;
};

/** All the different status labels for a vehicle */
export enum VehicleStatusLabel {
  /** Motor is on */
  Active = "ACTIVE",
  /** Motor is off */
  Inactive = "INACTIVE",
  /** Device is offline */
  NoConnection = "NO_CONNECTION",
  /** No device is assigned */
  NoDeviceAssigned = "NO_DEVICE_ASSIGNED",
}

/**
 * The vehicle status selection
 *
 * Used in queries to filter vehicles by their status
 */
export enum VehicleStatusSelection {
  /** Motor is on */
  Active = "ACTIVE",
  /** Motor is off */
  Inactive = "INACTIVE",
  /** Device is offline */
  NoConnection = "NO_CONNECTION",
  /** No device is assigned */
  NoDeviceAssigned = "NO_DEVICE_ASSIGNED",
  /** Vehicle status cannot be determined */
  Unknown = "UNKNOWN",
}

export enum WarningStatus {
  Level_1 = "LEVEL_1",
  Level_2 = "LEVEL_2",
  NoFault = "NO_FAULT",
  Unknown = "UNKNOWN",
}

export enum WorkingState {
  Charging = "CHARGING",
  Discharging = "DISCHARGING",
  Unknown = "UNKNOWN",
}

export type CharacteristicsFragment = {
  __typename?: "EndUser";
  characteristics: {
    __typename?: "Characteristics";
    vehicleCharacteristics: {
      __typename?: "VehicleCharacteristics";
      bmsCapacity: {
        __typename?: "BmsCapacityQuery";
        last?: {
          __typename?: "BmsCapacityMessage";
          remainingCapacity: number;
          fullCapacity: number;
          cycleCount: number;
        } | null;
      };
      bmsOutputVoltage: {
        __typename?: "BmsOutputVoltageQuery";
        last?: { __typename?: "BmsOutputVoltageMessage"; data: number } | null;
      };
      bmsMaxTemperature: {
        __typename?: "BmsMaxTemperatureQuery";
        last?: { __typename?: "BmsMaxTemperatureMessage"; data: number } | null;
      };
      estimatedDistance: {
        __typename?: "EstimatedDistanceQuery";
        last?: { __typename?: "EstimatedDistanceMessage"; data: number } | null;
      };
      estimatedDailyDistance: {
        __typename?: "EstimatedDailyDistanceQuery";
        last?: {
          __typename?: "EstimatedDailyDistanceMessage";
          data: number;
        } | null;
      };
      batteryStatus: {
        __typename?: "BatteryInfoQuery";
        last?: {
          __typename?: "BatteryInfoMessage";
          totalVoltage: number;
          soc: number;
          soh: number;
        } | null;
      };
      cellTemperatureInfo: {
        __typename?: "CellTemperatureInfoQuery";
        last?: {
          __typename?: "CellTemperatureInfoMessage";
          average: number;
        } | null;
      };
      batteryCapacity: {
        __typename?: "BatteryCapacityQuery";
        last?: {
          __typename?: "BatteryCapacityMessage";
          cycleCount: number;
        } | null;
      };
    };
  };
};

export type VehicleFragment = {
  __typename?: "EndUser";
  vehicle?: {
    __typename?: "Vehicle";
    vinNo: string;
    productionDate?: any | null;
    model: VehicleModel;
  } | null;
};

export type GetCharacteristicsQueryVariables = Exact<{
  timestamp: Scalars["DateTime"]["input"];
}>;

export type GetCharacteristicsQuery = {
  __typename?: "Query";
  currentEndUser: {
    __typename?: "EndUser";
    characteristics: {
      __typename?: "Characteristics";
      vehicleCharacteristics: {
        __typename?: "VehicleCharacteristics";
        bmsCapacity: {
          __typename?: "BmsCapacityQuery";
          last?: {
            __typename?: "BmsCapacityMessage";
            remainingCapacity: number;
            fullCapacity: number;
            cycleCount: number;
          } | null;
        };
        bmsOutputVoltage: {
          __typename?: "BmsOutputVoltageQuery";
          last?: {
            __typename?: "BmsOutputVoltageMessage";
            data: number;
          } | null;
        };
        bmsMaxTemperature: {
          __typename?: "BmsMaxTemperatureQuery";
          last?: {
            __typename?: "BmsMaxTemperatureMessage";
            data: number;
          } | null;
        };
        estimatedDistance: {
          __typename?: "EstimatedDistanceQuery";
          last?: {
            __typename?: "EstimatedDistanceMessage";
            data: number;
          } | null;
        };
        estimatedDailyDistance: {
          __typename?: "EstimatedDailyDistanceQuery";
          last?: {
            __typename?: "EstimatedDailyDistanceMessage";
            data: number;
          } | null;
        };
        batteryStatus: {
          __typename?: "BatteryInfoQuery";
          last?: {
            __typename?: "BatteryInfoMessage";
            totalVoltage: number;
            soc: number;
            soh: number;
          } | null;
        };
        cellTemperatureInfo: {
          __typename?: "CellTemperatureInfoQuery";
          last?: {
            __typename?: "CellTemperatureInfoMessage";
            average: number;
          } | null;
        };
        batteryCapacity: {
          __typename?: "BatteryCapacityQuery";
          last?: {
            __typename?: "BatteryCapacityMessage";
            cycleCount: number;
          } | null;
        };
      };
    };
  };
};

export type GetVehicleLocationQueryVariables = Exact<{ [key: string]: never }>;

export type GetVehicleLocationQuery = {
  __typename?: "Query";
  currentEndUser: {
    __typename?: "EndUser";
    characteristics: {
      __typename?: "Characteristics";
      deviceCharacteristics: {
        __typename?: "DeviceCharacteristics";
        geolocation: {
          __typename?: "GeoLocationQuery";
          current?: {
            __typename?: "GeoLocationMessage";
            latitude: number;
            longitude: number;
          } | null;
        };
      };
    };
  };
};

export type GetVehicleInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetVehicleInfoQuery = {
  __typename?: "Query";
  currentEndUser: {
    __typename?: "EndUser";
    vehicle?: {
      __typename?: "Vehicle";
      vinNo: string;
      productionDate?: any | null;
      model: VehicleModel;
    } | null;
  };
};

export const CharacteristicsFragmentDoc = gql`
  fragment Characteristics on EndUser {
    characteristics {
      vehicleCharacteristics {
        bmsCapacity {
          last(timestamp: $timestamp) {
            remainingCapacity
            fullCapacity
            cycleCount
          }
        }
        bmsOutputVoltage {
          last(timestamp: $timestamp) {
            data
          }
        }
        bmsMaxTemperature {
          last(timestamp: $timestamp) {
            data
          }
        }
        estimatedDistance {
          last(timestamp: $timestamp) {
            data
          }
        }
        estimatedDailyDistance {
          last(timestamp: $timestamp) {
            data
          }
        }
        batteryStatus {
          last(timestamp: $timestamp) {
            totalVoltage
            soc
            soh
          }
        }
        cellTemperatureInfo {
          last(timestamp: $timestamp) {
            average
          }
        }
        batteryCapacity {
          last(timestamp: $timestamp) {
            cycleCount
          }
        }
      }
    }
  }
`;
export const VehicleFragmentDoc = gql`
  fragment Vehicle on EndUser {
    vehicle {
      vinNo
      productionDate
      model
    }
  }
`;
export const GetCharacteristicsDocument = gql`
  query GetCharacteristics($timestamp: DateTime!) {
    currentEndUser {
      ...Characteristics
    }
  }
  ${CharacteristicsFragmentDoc}
`;

export function useGetCharacteristicsQuery(
  options: Omit<Urql.UseQueryArgs<GetCharacteristicsQueryVariables>, "query">,
) {
  return Urql.useQuery<
    GetCharacteristicsQuery,
    GetCharacteristicsQueryVariables
  >({ query: GetCharacteristicsDocument, ...options });
}
export const GetVehicleLocationDocument = gql`
  query GetVehicleLocation {
    currentEndUser {
      characteristics {
        deviceCharacteristics {
          geolocation {
            current {
              latitude
              longitude
            }
          }
        }
      }
    }
  }
`;

export function useGetVehicleLocationQuery(
  options?: Omit<Urql.UseQueryArgs<GetVehicleLocationQueryVariables>, "query">,
) {
  return Urql.useQuery<
    GetVehicleLocationQuery,
    GetVehicleLocationQueryVariables
  >({ query: GetVehicleLocationDocument, ...options });
}
export const GetVehicleInfoDocument = gql`
  query GetVehicleInfo {
    currentEndUser {
      ...Vehicle
    }
  }
  ${VehicleFragmentDoc}
`;

export function useGetVehicleInfoQuery(
  options?: Omit<Urql.UseQueryArgs<GetVehicleInfoQueryVariables>, "query">,
) {
  return Urql.useQuery<GetVehicleInfoQuery, GetVehicleInfoQueryVariables>({
    query: GetVehicleInfoDocument,
    ...options,
  });
}
